import { NgModule } from '@angular/core';
import { NgxUiLoaderHttpModule } from 'ngx-ui-loader';
import { ServiceplanComponent } from './serviceplan/serviceplan.component';
import { ServiceplanFormComponent } from './serviceplan-form/serviceplan-form.component';
import { ServiceplanrateComponent } from './serviceplanrate/serviceplanrate.component';

@NgModule({
  
  imports: [
   NgxUiLoaderHttpModule.forRoot({ showForeground: true, exclude: ["api/Auth/refreshToken", "api/ColumnChange/Savewidth?", "api/ColumnChange/getwidth?", "api/Claims/checkClaimCreationProgressPurchase?", "api/Claims/checkClaimCreationProgress?", "api/Claims/checkClaimCreationProgressTransaction?"] }),
  ],
  
  declarations: [
  
  
    
  
    
  ],
})
export class PagesModule { }
